import { InfrontSDK } from "@infront/sdk";
import { getInfrontSDKSnapshot } from "./infrontSDK";
import { trackMessage } from "@portal/appInsights";
import { stocksStore } from "../externalStore/infrontStockStore";

export const subscriber = (feedId: number, tickerCode: string, exit = false) => {
  const { instance: sdkInstance, isReady } = getInfrontSDKSnapshot();
  if (!sdkInstance || !isReady) return;

  sdkInstance.get(
    InfrontSDK.symbolData({
      id: {
        feed: feedId,
        ticker: tickerCode,
      },
      subscribe: true,
      onData: (data: InfrontSDK.SymbolData) => {
        data.observe(InfrontSDK.SymbolField.YesterdayClose, (value: number | string) => {
          stocksStore.updateStock(tickerCode, "yesterdayClose", value);
        });
        data.observe(InfrontSDK.SymbolField.Last, (value: number | string) => {
          stocksStore.updateStock(tickerCode, "last", value);
        });
        data.observe(InfrontSDK.SymbolField.Change, (value: number | string) => {
          stocksStore.updateStock(tickerCode, "change", value);
        });
        data.observe(InfrontSDK.SymbolField.ChangePercent, (value: number | string) => {
          stocksStore.updateStock(tickerCode, "changePercent", value);
        });
        data.observe(InfrontSDK.SymbolField.FullName, (value: number | string) => {
          // must set feed here since listening to feed symbol will return feed on all requested feeds
          stocksStore.updateStock(tickerCode, "name", value);
          stocksStore.updateStock(tickerCode, "feed", feedId);
        });
        data.observe(InfrontSDK.SymbolField.Turnover, (value: number | string) => {
          stocksStore.updateStock(tickerCode, "turnover", value);
        });
        data.observe(InfrontSDK.SymbolField.ISIN, (value: number | string) => {
          stocksStore.updateStock(tickerCode, "isin", value);
        });
        data.observe(InfrontSDK.SymbolField.CountryFlag, (value: number | string) => {
          stocksStore.updateStock(tickerCode, "flag", value);
        });
        data.observe(InfrontSDK.SymbolField.SymbolSubType, (value: number | string) => {
          stocksStore.updateStock(tickerCode, "instrumentSubType", value);
        });
        data.observe(InfrontSDK.SymbolField.DisplaySymbolStatus, (value: number | string) => {
          stocksStore.updateStock(tickerCode, "displaySymbolStatus", value);
        });
      },
      onError: (error: unknown) => {
        if (typeof error === "string") {
          trackMessage(`Infront SDK SymbolData subscriber error for ${tickerCode} and ${feedId} error=${error}`);
          return;
        } else if (
          error instanceof InfrontSDK.SystemError &&
          (error as InfrontSDK.SystemError)?.parameters?.code &&
          (error as InfrontSDK.SystemError).parameters.code === 404 &&
          !exit
        ) {
          const secondaryFeedId = feedId === 18199 ? 18177 : 18199;
          trackMessage(
            `Infront SDK SymbolData subscriber error for ${tickerCode} and ${feedId}, trying secondary feed ${secondaryFeedId} error=${JSON.stringify(error)}`,
          );
          subscriber(secondaryFeedId, tickerCode, true);
        } else {
          trackMessage(`Infront SDK SymbolData subscriber error for ${tickerCode} and ${feedId} error=${JSON.stringify(error)}`);
        }
      },
    }),
  );
};
